import { render } from "./ShippingOption.vue?vue&type=template&id=ef7ff5c2&scoped=true"
import script from "./ShippingOption.vue?vue&type=script&lang=js"
export * from "./ShippingOption.vue?vue&type=script&lang=js"

import "./ShippingOption.vue?vue&type=style&index=0&id=ef7ff5c2&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef7ff5c2"]])

export default __exports__